import { gql } from '@apollo/client';

export const GET_BLOG_POST_WITH_ALL_LOCALES_QUERY = gql`
  fragment CommonBlogPostFields on BlogPost {
    id
    locale
    title
    content
    bannerImage {
      id
      url
      formats
    }
    website
    hidden
  }

  query GetBlogPostWithAllLocales($id: ID!) {
    blogPost(id: $id) {
      ...CommonBlogPostFields
      localizations {
        ...CommonBlogPostFields
      }
    }
  }
`;
